var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.10417 12.3118L14.3333 6.08268C14.4849 5.9299 14.6616 5.85352 14.8635 5.85352C15.0656 5.85352 15.2431 5.9299 15.3958 6.08268C15.5486 6.23546 15.625 6.4131 15.625 6.6156C15.625 6.8181 15.5513 6.99303 15.404 7.14039L8.64583 13.916C8.49431 14.0688 8.31757 14.1452 8.11562 14.1452C7.91354 14.1452 7.73611 14.0688 7.58333 13.916L4.60417 10.9368C4.45139 10.7841 4.375 10.607 4.375 10.4056C4.375 10.2042 4.45139 10.0271 4.60417 9.87435C4.75694 9.72157 4.93521 9.64518 5.13896 9.64518C5.34257 9.64518 5.51847 9.72157 5.66667 9.87435L8.10417 12.3118Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckWhite);
export default __webpack_public_path__ + "static/media/check-white.9ca4732214f2075742b697bf083fa8e1.svg";
export { ForwardRef as ReactComponent };